@let disabledIdsVal = disabledIds();
@let itemsVal = vm.items();
@let totalCountVal = vm.totalCount();
@let isLoadingVal = vm.isLoading();
@let selectedIdsSize = vm.selectedIds.size;

<rt-dialog-header
  [heading]="translationKeys[kind].header | translate: { member: memberName }"
  [subheading]="translationKeys[kind].subheader | translate"
/>

<rt-dialog-body>
  @if (totalCountVal === undefined || itemsVal === undefined) {
    <div
      layout
      layout-full-height
      layout-full-width
      layout-align-items-center
      layout-justify-center
    >
      <rt-spinner />
    </div>
  }
  @if (totalCountVal !== null && itemsVal) {
    <div column-layout layout-full-width>
      <rt-box variant="vertical no-padding">
        <div class="search">
          <rt-form-field>
            <rt-input
              [formControl]="queryControl"
              variant="rounded"
              [placeholder]="translationKeys[kind].searchPlaceholder | translate"
              [hasClearButton]="true"
              (reset)="queryControl.reset('')"
            >
              <rt-icon name="search" prefix />
            </rt-input>
          </rt-form-field>
        </div>

        <rt-divider variant="line" />
        @if (totalCountVal > 0) {
          <virtual-scroller
            #scroll
            [executeRefreshOutsideAngularZone]="true"
            [scrollThrottlingTime]="0"
            [scrollAnimationTime]="0"
            [items]="itemsVal"
            (vsEnd)="vm.fetchMore($event)"
            (vsUpdate)="cdRef.detectChanges()"
            [class.loading]="isLoadingVal"
          >
            @for (group of scroll.viewPortItems; track group.guid) {
              <div
                [rtTooltipMaxWidth]="260"
                [rtTooltip]="
                  disabledIdsVal[group.guid] && (translationKeys[kind].alreadyAdded | translate)
                "
                rtTooltipPosition="left"
                [class.disabled]="disabledIdsVal[group.guid]"
                class="result"
              >
                <rt-group
                  (click)="vm.toggleAssignment(group.guid, disabledIdsVal[group.guid], $event)"
                  variant="horizontal"
                >
                  <rt-checkbox
                    (click)="vm.toggleAssignment(group.guid, disabledIdsVal[group.guid], $event)"
                    [checked]="disabledIdsVal[group.guid] || vm.selectedIds.has(group.guid)"
                    [disabled]="disabledIdsVal[group.guid]"
                    [value]="$any(group.guid)"
                  />
                  <rt-avatar
                    [iconName]="icons[kind].name"
                    [shape]="icons[kind].shape"
                    type="icon"
                    customIconBackgroundColor="colorAvatarGrayDark"
                    customIconColor="colorIconOncomponentDefault"
                    size="base"
                  />
                  <div layout-vertical margin-left-small>
                    <rt-heading>
                      <rt-truncate> {{ group.name }} </rt-truncate>
                    </rt-heading>
                    <span
                      ><rt-truncate>{{
                        translationKeys[kind].groupMembers
                          | translate: { count: group.membersCount }
                      }}</rt-truncate></span
                    >
                  </div>
                </rt-group>
                <rt-divider />
              </div>
            }
          </virtual-scroller>
        }

        @if (!isLoadingVal && totalCountVal === 0) {
          <div layout layout-full-height layout-align-items-center layout-justify-center>
            @if (queryControl.value) {
              <rt-empty-state
                [icon]="'search'"
                [title]="translationKeys[kind].emptyState | translate"
                variant="small"
                padding
              >
                <rt-button (click)="queryControl.reset('')" variant="tertiary">
                  {{ translationKeys[kind].clearSearch | translate }}
                </rt-button>
              </rt-empty-state>
            }
            @if (!queryControl.value) {
              <rt-empty-state
                [title]="translationKeys[kind].emptyState | translate"
                [icon]="icons[kind].name"
                variant="small"
                padding
              />
            }
          </div>
        }
        @if (isLoadingVal && totalCountVal === 0) {
          <div layout layout-full-height layout-align-items-center layout-justify-center>
            <rt-spinner />
          </div>
        }
      </rt-box>
    </div>
  }
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="closeDialog()" variant="plain">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button
    [disabled]="selectedIdsSize === 0"
    [loading]="saveLoading()"
    (click)="submit()"
    variant="primary"
  >
    {{ translationKeys[kind].addGroups | translate: { count: selectedIdsSize } }}
  </rt-button>
</rt-dialog-footer>
